$(() => {
  // 缓存DOM选择器和常量
  const DOM = {
    content: $('.modules-content'),
    leftBtn: $('.switch-left'),
    rightBtn: $('.switch-right')
  };
  
  const CONFIG = {
    itemWidth: DOM.content.width() / 4,
    totalItems: DOM.content.children().length,
    transitionDuration: 300,
    images: {
      leftActive: '../../../images/home/switch-l.png',
      leftDisabled: '../../../images/home/switch-l-n.png',
      rightActive: '../../../images/home/switch-r.png',
      rightDisabled: '../../../images/home/switch-r-n.png'
    }
  };

  let currentPosition = 0;
  const maxPosition = Math.max(0, CONFIG.totalItems - 4);

  // 事件处理函数
  const handlers = {
    moveLeft: () => {
      if (currentPosition > 0) {
        currentPosition--;
        updatePosition();
      }
    },
    
    moveRight: () => {
      if (currentPosition < maxPosition) {
        currentPosition++;
        updatePosition();
      }
    }
  };

  // 更新位置和按钮状态
  const updatePosition = () => {
    requestAnimationFrame(() => {
      const translateX = -currentPosition * CONFIG.itemWidth;
      DOM.content.css({
        transform: `translateX(${translateX}px)`,
        transition: `transform ${CONFIG.transitionDuration}ms ease-in-out`
      });
      updateButtonState();
    });
  };

  // 更新按钮状态
  const updateButtonState = () => {
    const { leftBtn, rightBtn } = DOM;
    const { images } = CONFIG;

    // 左按钮状态
    updateButton(leftBtn, currentPosition === 0, images.leftDisabled, images.leftActive);
    // 右按钮状态
    updateButton(rightBtn, currentPosition >= maxPosition, images.rightDisabled, images.rightActive);
  };

  // 更新单个按钮状态
  const updateButton = ($btn, isDisabled, disabledImg, activeImg) => {
    $btn.css({
      'background-image': `url("${isDisabled ? disabledImg : activeImg}")`,
      'cursor': isDisabled ? 'not-allowed' : 'pointer'
    });
  };

  // 初始化
  const init = () => {
    updateButtonState();
    // 事件绑定
    DOM.leftBtn.on('click', handlers.moveLeft);
    DOM.rightBtn.on('click', handlers.moveRight);
    
    // 添加窗口大小改变时的处理
    $(window).on('resize', _.debounce(() => {
      CONFIG.itemWidth = DOM.content.width() / 4;
      updatePosition();
    }, 250));
  };

  init();
});
